import { render, staticRenderFns } from "./rectSpin.vue?vue&type=template&id=936ec000&scoped=true"
import script from "./rectSpin.vue?vue&type=script&lang=js"
export * from "./rectSpin.vue?vue&type=script&lang=js"
import style0 from "./rectSpin.vue?vue&type=style&index=0&id=936ec000&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936ec000",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('936ec000')) {
      api.createRecord('936ec000', component.options)
    } else {
      api.reload('936ec000', component.options)
    }
    module.hot.accept("./rectSpin.vue?vue&type=template&id=936ec000&scoped=true", function () {
      api.rerender('936ec000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading/spin/rectSpin.vue"
export default component.exports